module.exports = __webpack_public_path__ + "img/微信钱包.44386587.svg";